import React, { createContext, useContext } from 'react';

export const TelemetrySectionContext = createContext<string | undefined>(undefined);

export interface TelemetrySectionProps {
  name: string;
  children: React.ReactNode;
}

/**
 * Context Provider to define current section/card scope for UI telemetry events.
 */
export const TelemetrySection: React.FC<TelemetrySectionProps> = ({ name, children }) => {
  return (
    <TelemetrySectionContext.Provider value={name}>
      {children}
    </TelemetrySectionContext.Provider>
  );
};

/**
 * Hook to retrieve the current telemetry section name from context.
 */
export const useTelemetrySection = (): string | undefined => {
  return useContext(TelemetrySectionContext);
};

export default TelemetrySection;
